export default function* mergeIterables<X, Y>(
  xs: Iterable<X>, ys: Iterable<Y>, before: (x: X, y: Y) => boolean,
): IterableIterator<X | Y> {
  const xIter = xs[Symbol.iterator]();
  const yIter = ys[Symbol.iterator]();

  let x = xIter.next();
  let y = yIter.next();

  while (!x.done && !y.done) {
    if (before(x.value, y.value)) {
      yield x.value;
      x = xIter.next();
    } else {
      yield y.value;
      y = yIter.next();
    }
  }

  while (!x.done) {
    yield x.value;
    x = xIter.next();
  }

  while (!y.done) {
    yield y.value;
    y = yIter.next();
  }
}

export function* flattenIterators<T>(items: Iterable<Iterable<T>>): Iterable<T> {
  for (const item of items) {
    yield* item;
  }
}
